import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading)
        return (
            <div className="min-h-screen grid place-items-center bg-white">
                <Loader2 className="w-6 h-6 animate-spin text-slate-400" />
            </div>
        );

    if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;
    return children;
}
